<template>
  <div>
    <!-- PC -->
    <v-app-bar class="d-none d-md-flex res_wrap navbar px-2" height="90" padless fixed flat :class="{ 'on': showNavbar }" @mouseover="mouseOver" @mouseout="mouseOut">
      <div class="d-flex align-center logo-container">
        <a @click="movePage('Home');">
          <img alt="Vuetify Logo" class="shrink mr-2 logo-d" src="@/assets/logo_header_d.svg" />
          <img alt="Vuetify Logo" class="shrink mr-2 logo-l" src="@/assets/logo_header_l.svg" />
        </a>
      </div>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click="drawer = true" class="d-lg-none" :class="{ 'white--text':!showNavbar }"></v-app-bar-nav-icon>
      <div class="nav d-none d-lg-block" :class="{ 'on':isMenuHover }" @mouseover="isMenuHover=true" @mouseout="isMenuHover=false">
        <div class="gnb">
          <ul>
            <li v-for="menu in menus" :key="menu.id">
              <a @click="movePage(menu.target);" exact>{{menu.title}}</a>
              <div class="twoDepthBox" v-if="menu.childrens">
                <ul>
                  <li v-for="children in menu.childrens" :key="children.id">
                    <a @click="movePage(children.target, children.hash_tar);" exact>{{children.title}}</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="gnb-sub-bg"></div>
      </div>
    </v-app-bar>

    <!-- Mobile -->
    <v-app-bar class="d-md-none res_wrap navbar px-2 mob" height="50" padless fixed flat :class="{ 'on': showNavbar }" @mouseover="mouseOver" @mouseout="mouseOut">
      <div class="d-flex align-center logo-container">
        <a @click="movePageM('Home');">
          <img alt="Vuetify Logo" class="shrink mr-2 logo-d" src="@/assets/logo_header_d.svg" />
          <img alt="Vuetify Logo" class="shrink mr-2 logo-l" src="@/assets/logo_header_l.svg" />
        </a>
      </div>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click="drawer = true" class="d-lg-none" :class="{ 'white--text':!showNavbar }"></v-app-bar-nav-icon>
      <div class="nav d-none d-lg-block" :class="{ 'on':isMenuHover }" @mouseover="isMenuHover=true" @mouseout="isMenuHover=false">
        <div class="gnb-sub-bg"></div>
      </div>
    </v-app-bar>
    

    <v-navigation-drawer class="nav-aside d-lg-none py-4" width="320px" v-model="drawer" fixed right temporary>
      <v-list nav dense>
        <v-list-item @click="movePageM('Home');">
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <hr class="mt-2 mb-2">
        <v-list-item-group>
            <template v-for="menu in menus">
              <template v-if="menu.childrens"> <!-- 자식 메뉴가 있는경우 -->
                <v-list-group :key="menu.id">
                  <template v-slot:activator>
                    <v-list-item-title>{{menu.title}}</v-list-item-title>
                  </template>
                  <template v-for="children in menu.childrens">
                    <v-list-item :key="children.id" @click="movePageM(children.target, children.hash_tar);" class="ml-2">
                      <v-list-item-title>
                        {{children.title}}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-list-group>
              </template>
              <template v-else> <!-- 단일 메뉴일 경우 -->
                <v-list-item :key="menu.id" @click="movePageM(menu.target);">
                  <v-list-item-title>{{menu.title}}</v-list-item-title>
                </v-list-item>
              </template>
            </template>
          </v-list-item-group>
        </v-list>

    </v-navigation-drawer>


    <div class="blur-box" :class="{ on: isMenuHover }"></div>


  </div>

    
</template>

<script>
  const OFFSET = 60;
  export default {
    name: 'main-header',
    data () {
      return {
        title: void 0,
        drawer: false,
        group: null,

        showNavbar: false,
        isHover: false,
        isMenuHover: false,
        isGoing: false,

        menus: [
          { id:1,     title:'Company',                            target: 'company',        childrens:[
            { id:11,  title:'Vision',                             target: 'company',        hash_tar: '#vision', },
            { id:12,  title:'CEO Message',                        target: 'company',        hash_tar: '#ceo', },
            { id:13,  title:'History',                            target: 'company',        hash_tar: '#history', },
            { id:14,  title:'Customer / Partner',                 target: 'company',        hash_tar: '#customer', },
            { id:15,  title:'Location',                           target: 'company',        hash_tar: '#location', },
          ]},
          { id:2,     title:'Service',                            target: 'service',        childrens:[
            { id:21,  title:'Our Specialized IT Solutions',       target: 'service',        hash_tar: '#solutions',},
            { id:22,  title:'Digital Transformation',             target: 'service',        hash_tar: '#transformation',},
            { id:23,  title:'System Integration',                 target: 'service',        hash_tar: '#integration',},
            { id:24,  title:'IT Consulting',                      target: 'service',        hash_tar: '#consulting',},
            { id:25,  title:'IT Outsourcing',                     target: 'service',        hash_tar: '#outsourcing',},
          ]},
          { id:3,     title:'Product',                            target: 'product',        childrens:[
            { id:31,  title:'JBot(RPA)',                          target: 'product',        hash_tar: '#jbot',},
            { id:32,  title:'JBot Portal(RPA)',                   target: 'product',        hash_tar: '#jbotportal',},
            { id:33,  title:'Auto-Station',                       target: 'product',        hash_tar: '#autostation',},
            { id:34,  title:'SAMSUNG SDS Brity RPA',              target: 'product',        hash_tar: '#brityrpa',},
            { id:35,  title:'SAMSUNG SDS Brity Assistant',        target: 'product',        hash_tar: '#brityassistant',},
            { id:36,  title:'TIBCO',                              target: 'product',        hash_tar: '#tibco',},
            { id:37,  title:'JSF(Jein SAP Interface Framework)',  target: 'product',        hash_tar: '#jsf',},
          ]},
          { id:4,     title:'Contact Us',                         target: 'contactus',},
        ]
      }
    },
    methods: {
      showTitle () {
        this.title = 'The main header'
      },

      handleScroll (event) {
        this.showNavbar = this.chkHeaderOn();
      },

      mouseOver () {
        this.isHover = true;
        this.showNavbar = this.chkHeaderOn()
      },

      mouseOut () {
        this.isHover = false;
        this.isGoing = false;
        this.showNavbar = this.chkHeaderOn()
      },

      chkHeaderOn () {
        if (this.isGoing) {
          return false;
        } else if (this.isHover) {
          return true;
        } else {
          return OFFSET < window.pageYOffset ? true : false;
        }
      },

      movePage(target, hash_tar){
        this.isHover = false;
        this.isMenuHover = false;
        this.isGoing = true;
        this.showNavbar = this.chkHeaderOn();
        this.$router.push({ name: target, hash: hash_tar });
      },
      movePageM(target, hash_tar){
        this.$router.push({ name: target, hash: hash_tar });
      },
    },

    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }
</script>

<style lang="scss" scoped>
  
</style>